import { useState } from "react";
import { toast } from "sonner";
import { http, formatApiError } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { KidAvatar } from "@/components/live/KidAvatar";

const Person = ({ c, picked, onClick }) => (
  <button type="button" onClick={onClick} data-testid={`contact-${c.id}`}
    className={`w-full flex items-center gap-3 px-3 py-2 rounded-2xl border text-left text-sm ${picked ? "border-[#2C4A3E] bg-[#F1EADB]" : "border-[#E6DEC3] bg-white hover:bg-[#F7F3EB]"}`}>
    {c.role === "student" ? <KidAvatar a={c.kid_avatar} className="w-8 h-8" /> : <span className="w-8 h-8 rounded-full bg-[#E8B4B8] grid place-items-center font-semibold text-[#2C4A3E]">{c.name[0]}</span>}
    <span className="flex-1">{c.name}<span className="block text-[11px] text-stone-500" data-testid={`contact-role-${c.id}`}>{c.role === "student" ? `Grade ${c.grade}` : c.about?.length ? `${c.role === "teacher" ? "Teacher" : "Parent"} of ${c.about.join(" & ")}` : c.role[0].toUpperCase() + c.role.slice(1)}</span></span>
  </button>
);

export const NewChatDialog = ({ open, setOpen, contacts, group, onCreated }) => {
  const [picked, setPicked] = useState([]);
  const [name, setName] = useState("");
  const toggle = (id) => setPicked((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));
  const start = async (id) => {
    try { const r = await http.post("/coach-chat/direct", { user_id: id }); setOpen(false); onCreated(r.data.id); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const create = async (e) => {
    e.preventDefault();
    if (!picked.length) return toast.error("Pick at least one student");
    try { const r = await http.post("/coach-chat/groups", { name, student_ids: picked }); setOpen(false); setPicked([]); setName(""); onCreated(r.data.id); }
    catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="bg-[#FDFBF7] max-h-[85vh] overflow-y-auto" data-testid={group ? "new-group-dialog" : "new-chat-dialog"}>
        <DialogTitle className="font-display text-2xl text-[#2C4A3E]">{group ? "New group chat" : "New private chat"}</DialogTitle>
        {!contacts.length && <p className="text-sm text-stone-500" data-testid="no-contacts">No one to message yet.</p>}
        {group ? (
          <form onSubmit={create} className="space-y-3">
            <input value={name} onChange={(e) => setName(e.target.value)} required maxLength={60} placeholder="Group name, e.g. Reading Circle" data-testid="group-name-input"
              className="w-full px-4 py-2.5 rounded-xl bg-white border border-[#E6DEC3] text-sm focus:outline-none focus:border-[#2C4A3E]" />
            <div className="space-y-2">{contacts.filter((c) => c.role === "student").map((c) => <Person key={c.id} c={c} picked={picked.includes(c.id)} onClick={() => toggle(c.id)} />)}</div>
            <button data-testid="group-create-btn" className="w-full py-3 rounded-full bg-[#C87D53] text-white text-sm">Create group ({picked.length})</button>
          </form>
        ) : (
          <div className="space-y-4">
            {[["Students", contacts.filter((c) => c.role === "student")], ["Grown-ups", contacts.filter((c) => c.role !== "student")]].filter(([, l]) => l.length).map(([h, l]) => (
              <div key={h} className="space-y-2" data-testid={`contact-section-${h.toLowerCase()}`}><p className="text-[11px] uppercase tracking-[0.2em] text-stone-400">{h}</p>
                {l.map((c) => <Person key={c.id} c={c} onClick={() => start(c.id)} />)}</div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
